import { useRef } from 'react';

import { useSession } from '@erikdakoda/auth/client/betterAuthClient';

/**
 * Session state for auth guards. Better Auth sets `isPending` on every refetch while
 * `data` is null (guest users), which must not replace page content after the first check.
 */
export function useSessionGuardState(): {
  session: ReturnType<typeof useSession>['data'];
  isInitialSessionLoad: boolean;
  refetch: ReturnType<typeof useSession>['refetch'];
} {
  const { data: session, isPending, refetch } = useSession();
  const hasResolvedSession = useRef(false);

  if (!isPending) {
    hasResolvedSession.current = true;
  }

  const isInitialSessionLoad = isPending && !hasResolvedSession.current;

  return { session, isInitialSessionLoad, refetch };
}
